<template>
<v-container fluid class="white elevation-4 pt-0 pb-0">
    <main-app-bar :title="$router.currentRoute.meta.title"></main-app-bar>
    <v-row class="d-block lighten-4 d-flex justify-space-between align-center">
        <v-container>
            <div v-if="getClinicById(getUserActiveClinic).marketingDashboardUrl">
                <iframe class="marketing-iframe" :src="getClinicById(getUserActiveClinic).marketingDashboardUrl" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
            <div v-else>
                <h4 class="text-center py-2" style="width: 100%;">Marketing dashboard is not linked</h4>
            </div>
        </v-container>
    </v-row>
</v-container>
</template>

<script>
import MainAppBar from '@/components/MainAppBar'
import { mapGetters, mapActions } from 'vuex'

export default {
    computed: {
        ...mapGetters(['getSurgeryById', 'getUserActiveClinic', 'getClinicById'])
    },
    async mounted () {
        await this.fetchClinicInfo(this.getUserActiveClinic)
    },
    methods: {
        ...mapActions(['fetchClinicInfo'])
    },
    components: {
        MainAppBar
    }
}
</script>

<style scoped lang="scss">
    .marketing-iframe {
        width: 100%;
        height: calc(100vh - 150px);
    }
</style>
